import "core-js/modules/es.object.freeze.js";
export * from "./arrayEquals";
export * from "./auth/abjwt";
export { __do_not_use_this__reduxBeesHelpers } from "./auth/accessToken";
export * from "./camelizeProperties";
export * from "./capitalize";
export * from "./capitalizeHyphenated";
export * from "./constants";
export * from "./copyToClipboard";
export * from "./data";
export * from "./dataFetchingHelpers";
export * from "./dataFetchingHelpers/featureFlag";
export * from "./date";
export * from "./datetime";
export * from "./debounce";
export * from "./decisions";
export * from "./deepFlatten";
export * from "./disableEmotionWarnings";
export * from "./disableRechartsWarnings";
export * from "./ErrorBoundary";
export * from "./EventTracker";
export * from "./flatten";
export * from "./formatCurrency";
export * from "./formattedFileSize";
export * from "./generatePath";
export * from "./getCurrencySign";
export * from "./getObjectsWithIncludedRelationships";
export * from "./hooks";
export * from "./isNumeric";
export * from "./monolithEmailValidation";
export * from "./omit";
export * from "./PageMetaTitle";
export * from "./raiseErrorMessage";
export * from "./raiseInfoMessage";
export * from "./raiseSuccessMessage";
export * from "./raiseWarningMessage";
export * from "./shallowDiffers";
export * from "./snakeCaseCapitalizeFirst";
export * from "./snakeCaseToCamelCase";
export * from "./snakeCaseToTitleCase";
export * from "./titleize";
export * from "./types";
export * from "./UserContext";
export * from "./userHelpers";
export * from "./useSpeedcurveSnippet";
export * from "./i18n";
export * from "./trim";
export { JSONAPIError } from "./errors/JSONAPIError";
export { NetworkError } from "./errors/NetworkError";
export { assert } from "./assert";

/**
 * Empty array that always has the same object reference.  This can help prevent
 * re-renders if the reference is stable.
 *
 * It's also frozen so consumers don't accidentally change it. This kind of
 * mutation would cause hard-to-debug bugs
 */
export var emptyArray = Object.freeze([]); // DO NOT REMOVE Object.freeze

/**
 * Empty object that always has the same object reference.  This can help prevent
 * re-renders if the reference is stable.
 *
 * It's also frozen so consumers don't accidentally change it. This kind of
 * mutation would cause hard-to-debug bugs
 */
// eslint-disable-next-line @typescript-eslint/ban-types
export var emptyObject = Object.freeze({}); // DO NOT REMOVE Object.freeze